module.exports = __webpack_public_path__ + "img/Polygon.cccd0294.png";